module.exports = __webpack_public_path__ + "static/media/background.c06dc5fa.jpg";